var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M1 1H15C15.5531 1 16 1.44687 16 2V3C16 3.55312 15.5531 4 15 4H1C0.446875 4 0 3.55312 0 3V2C0 1.44687 0.446875 1 1 1ZM1 5H15V13C15 14.1031 14.1031 15 13 15H3C1.89688 15 1 14.1031 1 13V5ZM5 7.5C5 7.775 5.225 8 5.5 8H10.5C10.775 8 11 7.775 11 7.5C11 7.225 10.775 7 10.5 7H5.5C5.225 7 5 7.225 5 7.5Z",
          fill: "#1A7BEE",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }